<template>
	<div class="housekeeping">
		<v-layout row wrap>
			<v-flex md10 text-xs-left pl-3>
				<p>Estados de habitaciones:</p>
			</v-flex>
			<v-flex md2 class="search" text-xs-right>
				<input
				type="text" 
				value=""
				placeholder="Buscar huésped, habitaciones…">
				<v-btn icon>
					<v-icon>search</v-icon>
				</v-btn>
			</v-flex>
		</v-layout>
		<v-layout row wrap>
			<v-flex class="state-room" text-xs-left >
				<v-layout>
					<v-flex class="no-show" md3 id="1">
						<div class="icon"></div>
						<span>No Show</span>
					</v-flex>
					<v-flex class="check-inn" md3 id="2">
						<div class="icon"></div>
						<span>Check in</span>
					</v-flex>
					<v-flex class="checkout" id="3">
						<div class="icon"></div>
						<span>Check Out</span>	
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex  >
				<v-layout justify-end class="state-room">
					<v-flex> 
						<div class="icon maintenance"></div>
						<span>Mantenimiento</span>
					</v-flex>
					<v-flex>
						<div class="icon clean-bussy"></div>
						<span>Ocupado limpio</span>
					</v-flex>
					<v-flex >
						<div class="icon unclean-bussy"></div>
						<span>Ocupado sucio</span>
					</v-flex>
					<v-flex>
						<div class="icon clean-empty"></div>
						<span>Vacías limpias</span>
					</v-flex>
					<v-flex>
						<div class="icon unclean-empty"></div>
						<span>Vacías sucias</span>
					</v-flex>
				</v-layout>
			</v-flex>
		</v-layout>
		<v-layout wrap pt-4>
			<housekeeping-card
				v-for="booking in bookings"
				:key="booking.id"
				:image="booking.image"
				:roomNumber="booking.roomNumber" 
				:roomTypeCode="booking.roomTypeCode"
				:lastname="booking.client.lastname"
				:name="booking.client.name"
				:startDate="booking.startDate"
				:endDate="booking.endDate"
				:currency="booking.currency"
				:bookingTotal="booking.bookingTotal"
				:bookingColor="booking.color"
				/>
		</v-layout>
	</div>
</template>
<script>

import housekeepingCard from './../../components/shared/HousekeepingCard';

function data() {
	return {
		customStates: [
			{
				id: 1,
				image: '',
				name: 'no show',
			},
			{
				id: 2,
				image: '',
				name: 'Check in',
			},
			{
				id: 3,
				image: '',
				name: 'Check out',
			},
		],
		bookings: [
			{
				id: 1,
				roomNumber: 103,
				roomTypeCode: 'DSQ',
				roomState: 4,
				bookingState: 1,
				color: '#f5d623',
				client: {
					lastname: 'Dávila Guerrero',
					name: 'Jorge',
				},
				currency: 'USD',
				startDate: '21/05',
				endDate: '01/06',
				bookingTotal: 942.23,
				image: '/static/img/icon.png',
			},
			{
				id: 2,
				roomNumber: 103,
				roomTypeCode: 'DSQ',
				roomState: 4,
				bookingState: 1,
				color: '#ff0053',
				client: {
					lastname: 'Dávila Guerrero',
					name: 'Jorge',
				},
				currency: 'USD',
				startDate: '21/05',
				endDate: '01/06',
				bookingTotal: 942.23,
				image: '/static/img/icon.png',
			},
			{
				id: 3,
				roomNumber: 103,
				roomTypeCode: 'DSQ',
				roomState: 4,
				bookingState: 1,
				color: '#f6a623',
				client: {
					lastname: 'Dávila Guerrero',
					name: 'Jorge',
				},
				currency: 'USD',
				startDate: '21/05',
				endDate: '01/06',
				bookingTotal: 942.23,
				image: '/static/img/icon.png',
			},
			{
				id: 4,
				roomNumber: 103,
				roomTypeCode: 'DSQ',
				roomState: 4,
				bookingState: 1,
				color: '#f5d623',
				client: {
					lastname: 'Dávila Guerrero',
					name: 'Jorge',
				},
				currency: 'USD',
				startDate: '21/05',
				endDate: '01/06',
				bookingTotal: 942.23,
				image: '/static/img/icon.png',
			},
			{
				id: 5,
				roomNumber: 103,
				roomTypeCode: 'DSQ',
				roomState: 4,
				bookingState: 1,
				color: '#0fe270',
				client: {
					lastname: 'Dávila Guerrero',
					name: 'Jorge',
				},
				currency: 'USD',
				startDate: '21/05',
				endDate: '01/06',
				bookingTotal: 942.23,
				image: '/static/img/icon.png',
			},
			{
				id: 6,
				roomNumber: 103,
				roomTypeCode: 'DSQ',
				roomState: 4,
				bookingState: 1,
				color: '#97a6c2',
				client: {
					lastname: 'Dávila Guerrero',
					name: 'Jorge',
				},
				currency: 'USD',
				startDate: '21/05',
				endDate: '01/06',
				bookingTotal: 942.23,
				image: '/static/img/icon.png',
			},
			{
				id: 6,
				roomNumber: 103,
				roomTypeCode: 'DSQ',
				roomState: 4,
				bookingState: 1,
				color: '#0fcde2',
				client: {
					lastname: 'Dávila Guerrero',
					name: 'Jorge',
				},
				currency: 'USD',
				startDate: '21/05',
				endDate: '01/06',
				bookingTotal: 942.23,
				image: '/static/img/icon.png',
			},
		],
	};
}

export default {
	name: 'list',
	data,
	components: {
		housekeepingCard,
	},
};
</script>
<style lang="scss" scoped>
	.housekeeping{
		background-color: #fff;
		margin: 0px;
		padding: 18px 10px;	
		text-align: left;
		width: 100%;	
		.state-room{
			font-size: 14px;
			.no-show , .check-inn , .checkout{
				color: #818181;
				padding: 5px;	
				font-weight: normal;
				font-style: normal;
				font-stretch: normal;
				letter-spacing: normal;
				line-height: normal;
			}
		}
		.search{
			border: solid 1px  map-get($colors, boder-radio);
			border-radius: 9px;
			box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
			display: inline-flex;
			font-size: 12px;
			height: 34.3px;
			left: 0;
			padding:  0px 0px !important;
			right: 0;
			width: 274.8px;
			.btn--icon .btn__content{
				height: 14px;
				width: 14px;
			}
			input{
				color:  map-get($colors, bg-chart);
				font-size: 13px;
				font-weight: normal;
				font-style: normal;
				font-stretch: normal;
				height: 34px;
				line-height: normal;
				letter-spacing: normal;
				margin: 0 -2px;
				padding: 0px 8px;
    			text-align: left;
				width: 100%;

			}
		}
		.icon{
			border-radius: 2px;
			height: 8px;
			width: 8px;
			&.maintenance{
				background-color: #97a6c3;
			}
			&.clean-bussy{
				background-color: #0fcde2;
			}
			&.unclean-bussy{
				background-color: #ff0053;
			}
			&.clean-empty{
				background-color: #0fe270;
			}
			&.unclean-empty{
				background-color: #f5a623;
			}
		}
		.state-room{
			span{
				color: map-get($colors, realtime-label );
				font-weight: normal;
				font-style: normal;
				font-stretch: normal;
				letter-spacing: normal;
				line-height: normal;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// List.vue?772fce4e